import React from 'react';
import Stack from 'atoms/Layout/Stack/Stack';
import Typography from 'atoms/Typography/Typography';

const InactiveNetworkLayout = (): JSX.Element => (
  <Stack
    padding={['spacing-sm', 'spacing-none']}
    justify='center'
    align='center'
  >
    <Typography
      type='paragraph'
      size='md'
      textAlign='center'
      color='text-white'
    >
      That Network is no longer available. But why not create your own? <b>Explore everything you can do on Mighty.</b>{' '}
      👇
    </Typography>
  </Stack>
);

export default InactiveNetworkLayout;
